import CityPage from "../CityPage";
import { citiesData } from "@/mocks/cities";

export default function CityMeauxPage() {
  const data = citiesData.find((c) => c.slug === "meaux")!;
  return <CityPage data={data} />;
}
